import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { CiiBadgeComponent } from '../../../components/cii-badge/cii-badge.component';

@Component({
  selector: 'app-angular-migration',
  standalone: true,
  imports: [CiiBadgeComponent],
  templateUrl: './angular-migration.component.html',
  styleUrl: './angular-migration.component.css'
})
export class AngularMigrationComponent implements OnInit {

  constructor(
    private titleService: Title, 
    private metaService: Meta
  ) {}

  ngOnInit() {
    this.titleService.setTitle("Migration AngularJS vers Angular Moderne (v19+) — Expert Agréé CII");
    this.metaService.updateTag({ name: 'description', content: "Migration AngularJS vers Angular sans risque. Méthodologie progressive (ngUpgrade) sans interruption de service. Sécurisez et modernisez votre frontend avec nos experts." });
  }
}